import { url2data, fetchData } from "./fetch";

const invitationAPI = {
  /**
   * Get invitation information by token (no authentication required)
   */
  getInvitationInfo: async (token) => {
    return fetchData(`core/invitations/${token}/info`);
  },

  /**
   * Accept an invitation (requires authentication)
   */
  acceptInvitation: async (token) => {
    return url2data(`core/invitations/${token}/accept`, {});
  },
};

export default invitationAPI;
